import React from 'react';
import SitesTree from './components/SitesTree';
import SitesPageBody from './components/SitesPageBody';
import { message } from 'antd';
import { immer } from 'zustand/middleware/immer';
import { create } from 'zustand';
import { useTranslation } from 'react-i18next';

interface WarehouseState {
    warehouseId: number | null;
    setWarehouseId: (warehouseId: number) => void;
}

export const useWarehouseStore = create<WarehouseState>()(
    immer((set, get) => ({
        // 默认状态
        warehouseId: null,
        setWarehouseId: (warehouseId: number) => {
            set({ warehouseId });
        },
    }))
);


const SitesSettingPage: React.FC = () => {
    const { setWarehouseId } = useWarehouseStore(state => state);
    const { t } = useTranslation();

    const handleSiteSelect = async (siteId: string) => {
        console.log('handleSiteSelect', siteId);
        setWarehouseId(Number(siteId));
    };

    const handleAddHub = (hubName: string) => {
        console.log('Add new hub:', hubName);
        message.success(t('central.sites.messages.hubCreatedSuccessfully', {hubName}));
    };

    const handleAddWarehouse = (hubId: string, warehouseName: string) => {
        console.log('Add new warehouse:', hubId, warehouseName);
        message.success(t('central.sites.messages.warehouseCreatedSuccessfully', {warehouseName}));
    };

    return (
            <div className="flex h-full w-full min-w-0">
                <SitesTree
                    onSelect={handleSiteSelect}
                    onAddHub={handleAddHub}
                    onAddWarehouse={handleAddWarehouse}
                />
                <div className="flex-1 min-w-0 w-full p-4 flex flex-col gap-8">
                    <SitesPageBody />
                </div>
            </div>
    );
};

export default SitesSettingPage;
